export default __webpack_public_path__ + "static/0105-bdb819513b5f8ce47dcef26ea2e178a3.png";